import './App.scss';
import { BrowserRouter, Routes, Route, Link } from 'react-router-dom';
import Form from './features/form/Form';
import Table from './features/table/Table';
import Search from './features/search/Search';
import 'animate.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSignOut } from '@fortawesome/free-solid-svg-icons';
import { useEffect } from 'react';
import axios from 'axios';
import store from './store';
import appSlice from './appSlice';
import Analyze from './features/analyze/Analyze';
import logoIcon from './assets/img/logo.jpg';
import Dashboard from './features/dashboard/Dashboard';

function App() {

  useEffect(() => {
    // axios.get(`http://localhost/ariadne/get-data`).then((response) => {
    axios.get(`https://ariadne.page/get-data`).then((response) => {
      const data = response.data.map((record) => {
        return {
          id: record.id,
          winningNumbers: JSON.parse(record.winning_numbers),
          date: parseInt(record.date),
        };
      }).sort((a, b) => {
        if (a.date > b.date) {
          return -1;
        } else {
          return 1;
        }
      });

      store.dispatch(appSlice.actions.updateData(data));

      window.data = data;
    });
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Form></Form>}></Route>
          <Route path="/table" element={<Table></Table>}></Route>
          <Route path="/search" element={<Search></Search>}></Route>
          <Route path="/analyze" element={<Analyze></Analyze>}></Route>
          <Route path="/dashboard" element={<Dashboard></Dashboard>}></Route>
        </Routes>
      </BrowserRouter>

      <div className="logo">
        <span>Αριάδνη</span>
        <img src={logoIcon} style={{ marginTop: '8px' }} height="85" />
      </div>

      <a href="/ariadne/logout" className="btn-logout"><FontAwesomeIcon icon={faSignOut} size="lg" />&nbsp;Αποσύνδεση</a>
    </div>
  );
}

export default App;
